module.exports = __webpack_public_path__ + "static/media/macaron_label_reveal.4b21126d.png";